import { useEffect, useState } from 'react';

import {
  Box,
  PartThumbnail,
  Popover,
  PopoverAnchor,
  PopoverContent,
  Portal,
  Spinner,
} from '@frontend/legacy-components';

import FileTypeIcon from 'components/lib2/fileTypeIcon/FileTypeIcon';

import type { CadPopoverNodeData } from './';

type CadTreeThumbnailPopoverProps = {
  popoverNodeData: CadPopoverNodeData | null;
};

export const CadTreeThumbnailPopover = ({
  popoverNodeData,
}: CadTreeThumbnailPopoverProps) => {
  const { containsVirus, filename, fileType, partFileUuid } =
    popoverNodeData?.node ?? {};

  const [isOpen, setIsOpen] = useState(false);

  // Timeout for delay on hover
  useEffect(() => {
    if (popoverNodeData) {
      const timeout = setTimeout(() => {
        setIsOpen(true);
      }, 750);
      return () => {
        clearTimeout(timeout);
      };
    } else {
      setIsOpen(false);
    }
  }, [popoverNodeData]);

  return (
    <Popover
      isOpen={!!popoverNodeData && isOpen}
      size="sm"
      placement="top-start"
      hasArrow
    >
      <Portal>
        <PopoverAnchor>
          <Box
            position="absolute"
            top={`${popoverNodeData?.popoverPosition?.top ?? 0}px`}
            left={`${popoverNodeData?.popoverPosition?.left ?? 0}px`}
          />
        </PopoverAnchor>
        <PopoverContent w="200px" h="200px">
          <PartThumbnail
            containsVirus={!!containsVirus}
            fallbackComponent={<FileTypeIcon fileType={fileType} />}
            filename={filename}
            fileType={fileType}
            loadingComponent={<Spinner size="xl" />}
            loadLazily={false}
            partFileUuid={partFileUuid}
          />
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
